export default __webpack_public_path__ + "static/media/header.c1c62104.png";